// extracted by mini-css-extract-plugin
export default {"accountType":"AccountTypeForm_accountType__mR2U+","modal":"AccountTypeForm_modal__ncVzQ"};